export default __webpack_public_path__ + "alberta-search.ff9905b971495fc07562.svg";